import { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { InteractiveTable, StyledFlex } from '@dreryk/react-components';

type FacilityDescriptionCellProps = {
   readonly index: number;
   readonly externalAddressId: string;
   readonly children: ReactNode;
};

const StyledFacilityDescription = styled(StyledFlex)`
   padding: 14px 0;
`;
StyledFacilityDescription.displayName = 'StyledFacilityDescription';

export const FacilityDescriptionCell = (props: FacilityDescriptionCellProps): ReactElement => {
   return (
      <StyledFacilityDescription direction={'column'}>
         <InteractiveTable.ControllerCell
            name={'externalAddressId'}
            index={props.index}
            defaultValue={props.externalAddressId}
            testId={'externalAddressId'}
         />
         {props.children}
      </StyledFacilityDescription>
   );
};
